import { RouteConfig } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireProvider } from '@/router/guards/authGuards';
import { requireSupportedProfileEditCareType } from '@/router/guards/profileEditGuards';
import ProfileEditLayout from '@/apps/provider/profile/edit/ProfileEditLayout.vue';
import ProfileEditFormDispatcher from '@/apps/provider/profile/edit/ProfileEditFormDispatcher.vue';

const PROFILE_EDIT_SECTIONS = [
  {
    path: 'bio',
    name: 'provider-profile-edit-bio',
    title: 'Bio & Preferences',
  },
  {
    path: 'rates',
    name: 'provider-profile-edit-rates',
    title: 'Rates',
  },
  {
    path: 'experience',
    name: 'provider-profile-edit-experience',
    title: 'Experience',
  },
  {
    path: 'services',
    name: 'provider-profile-edit-services',
    title: 'Services',
  },
  {
    path: 'education',
    name: 'provider-profile-edit-education',
    title: 'Education',
  },
  {
    path: 'specialty-skills',
    name: 'provider-profile-edit-specialty-skills',
    title: 'Specialty Skills',
  },
];

const profileEditRoutes: RouteConfig[] = [
  {
    path: '/provider/profile/:care_type/edit',
    component: ProfileEditLayout,
    beforeEnter: combineGuards([requireProvider, requireSupportedProfileEditCareType]),
    children: [
      ...PROFILE_EDIT_SECTIONS.map((section) => ({
        path: section.path,
        name: section.name,
        component: ProfileEditFormDispatcher,
        props: { section: section.path },
        meta: {
          pageTrackingName: `Provider Profile Edit ${section.title}`,
          pageTrackingTitle: `Edit ${section.title}`,
        },
      })),
      {
        path: '',
        redirect: 'bio',
      },
    ],
  },
];

export default profileEditRoutes;
